import { isNumber } from 'lodash';
import { toLocaleBrowserSettings } from 'src/i18n/numberLocale';
import { SectionGridItem, SectionGridItemProps } from './SectionGridItem';

export type SectionGridNumericItemProps = Omit<SectionGridItemProps, 'value'> & {
  value: number | undefined | null;
};

export const SectionGridNumericItem = ({ value, ...props }: SectionGridNumericItemProps) => {
  return (
    <SectionGridItem {...props} value={isNumber(value) ? toLocaleBrowserSettings(value) : null} />
  );
};
